import React from "react";
import { SelectInput } from "../../../../Helpers/Inputs";
import { Form } from "react-bootstrap";
import { AccountTypes, OwnerType } from "../../../../Common/Constant";
import { policyOwnershipOptions, policyOwnerships } from "../Helpers/Constants";


export default function AccountTypesAndOwnerFields(props) {
    const { formState, register, errors, handleValueChange, clientData, ownerList, jointOwner, getOwnerList, getPrimaryOwner, getJointOwnerList } = props;

    return (
        <React.Fragment>
            {
                clientData.accountType && clientData.accountType.toLowerCase() === AccountTypes.JOINT &&
                <Form.Group>
                    <SelectInput
                        name="policyOwnership"
                        id="policyOwnership"
                        label="Is this policy individually or jointly owned?"
                        value={formState.policyOwnership}
                        selectOptions={policyOwnershipOptions}
                        onChange={e => handleValueChange('policyOwnership', e.target.value)}
                        errors={errors.policyOwnership}
                        labelCenter={true}
                    />
                </Form.Group>
            }

            {
                ownerList !== undefined && ownerList.length > 0 &&
                (
                    clientData.accountType &&
                    ([AccountTypes.INDIVIDUAL, AccountTypes.PARTNERSHIP].includes(clientData.accountType.toLowerCase()) ||
                        (clientData.accountType.toLowerCase() === AccountTypes.JOINT && formState.policyOwnership === policyOwnerships.INDIVIDUAL) ||
                        (clientData.accountType.toLowerCase() === AccountTypes.UNINCORPORATED && !clientData.accountSubclass.toLowerCase().includes(AccountTypes.UNINCORPORATED))
                    )
                ) &&
                (
                    <Form.Group>
                        <SelectInput
                            name="owner"
                            id="owner"
                            value={formState.owner}
                            onChange={(e) => handleValueChange('owner', e.target.value)}
                            label="Who is the owner?"
                            selectOptions={getOwnerList(ownerList)}
                            errors={errors.owner}
                            inputRef={register}
                        />
                    </Form.Group>
                )
            }

            {
                formState.policyOwnership === policyOwnerships.JOINT &&
                <React.Fragment>
                    <Form.Group>
                        <h6>Primary owner: {getPrimaryOwner().label}</h6>
                    </Form.Group>
                    {
                        jointOwner.length >= 1 &&
                        <Form.Group>
                            <SelectInput
                                name="jointOwner"
                                id="jointOwner"
                                value={formState.jointOwner}
                                onChange={(e) => handleValueChange('jointOwner', e.target.value)}
                                label="Who is the joint owner?"
                                selectOptions={getJointOwnerList(jointOwner)}
                                errors={errors.jointOwner}
                                inputRef={register}
                            />
                        </Form.Group>
                    }
                </React.Fragment>
            }

            {
                clientData.accountType &&
                ((clientData.accountType.toLowerCase() === AccountTypes.UNINCORPORATED && clientData.accountSubclass.toLowerCase().includes(AccountTypes.UNINCORPORATED)) ||
                    [AccountTypes.TRUST, AccountTypes.CORPORATION, AccountTypes.LIMITED_LIABILITY].includes(clientData.accountType.toLowerCase())) &&
                <Form.Group>
                    <h6><b>Company Name: </b>{getPrimaryOwner().label}</h6>
                    <p>For Business or Trust owned policies the owner cannot be the proposed insured.</p>
                </Form.Group>
            }
            {
                clientData.accountType && clientData.accountType.toLowerCase() === AccountTypes.UNINCORPORATED && clientData.accountSubclass.toLowerCase() === AccountTypes.SOLE_PROPRIETOR && formState.selectedOwner && formState.selectedOwner.ownerType && formState.selectedOwner.ownerType.toLowerCase() === OwnerType.ORGANIZATION &&
                <Form.Group>
                    <h8>For Unincorporated Sole Proprieter Business owned policies the owner cannot be the proposed
                        insured.
                    </h8>
                </Form.Group>
            }
            {
                clientData.accountType && clientData.accountType.toLowerCase() === AccountTypes.PARTNERSHIP && formState.selectedOwner && formState.selectedOwner.ownerType && formState.selectedOwner.ownerType.toLowerCase() === OwnerType.ORGANIZATION &&
                <Form.Group>
                    <h8>For Partnership owned policies the owner cannot be the proposed insured.</h8>
                </Form.Group>
            }
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/SubComponents/AccountTypesAndOwnerFields.js